import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  loading: false,
  contacts: [],
  noSipGivenAlert: false,
};

const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CONTACTS_LOADED:
      state = {
        contacts: action.payload.contacts,
        loading: false,
      };
      break;
    case ActionTypes.CONTACTS_LOADING:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ActionTypes.UPDATE_CONTACT_LOCALLY:
      if (action.payload.data.id === undefined) {
        return;
      }
      var idUpdate = parseInt(action.payload.data.id, 10);

      for (var i = 0; i < state.contacts.length; i++) {
        if (state.contacts[i].id === idUpdate) {
          state.contacts[i] = {
            ...action.payload.data,
            id: idUpdate,
          };
          state.loading = false;
          break;
        }
      }
      break;
    case ActionTypes.DELETE_CONTACT_LOCALLY:
      var idDelete = parseInt(action.payload.id, 10);
      for (var j = 0; j < state.contacts.length; j++) {
        if (state.contacts[j].id === idDelete) {
          state.contacts.splice(j, 1);
          state.loading = false;
          break;
        }
      }
      break;
    case ActionTypes.CONTACT_REMOVE_LOADING:
      state = {
        ...state,
        loading: false,
      };
      break;
    case ActionTypes.CONTACT_NO_SIP_GIVEN:
      state.noSipGivenAlert = true;
      break;
    case ActionTypes.CONTACT_CLEAR_ALERT:
      state.noSipGivenAlert = false;
      break;
    default:
      break;
  }
  return state;
};

export default contactReducer;






// WEBPACK FOOTER //
// ./src/reducers/contactReducer.js